/**
 * Supported file types for adding images.
 */
const supportedImageMimeTypesConst = [
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/gif',
  'image/svg+xml',
] as const;

/**
 * Supported file types for importing files.
 */
export const pdfImportMimeType = 'application/pdf';
const supportedFileImportMimeTypesConst = ['application/pdf'] as const;

export type SupportedImageMimeType = (typeof supportedImageMimeTypesConst)[number];
export type SupportedFileImportMimeType =
  (typeof supportedFileImportMimeTypesConst)[number];

export type FileType = SupportedImageMimeType | SupportedFileImportMimeType;

export const supportedImageMimeTypes = supportedImageMimeTypesConst as readonly string[];
export const supportedFileImportMimeTypes =
  supportedFileImportMimeTypesConst as readonly string[];

export const isSupportedImageMimeType = (
  mimeType: string,
): mimeType is SupportedImageMimeType => supportedImageMimeTypes.includes(mimeType);

export const isSupportedFileImportMimeType = (
  mimeType: string,
): mimeType is SupportedFileImportMimeType =>
  supportedFileImportMimeTypes.includes(mimeType);

export const isSupportedFileType = (mimeType: string): mimeType is FileType =>
  isSupportedImageMimeType(mimeType) || isSupportedFileImportMimeType(mimeType);
